import React, { useState, useCallback, ReactElement } from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox, { Modal, ModalGateway } from 'react-images';
import { GridProps, GridImage } from '../interfaces';
import { server } from '../const/axios';

const imgRatio = /_.*([0-9]+,[0-9]+)\./;

export function buildGrid(paths: string[], i: number, id: string, {ratio, ratios = []}: {
	ratio: [number, number],
	ratios: [number, number, number?][]
}): GridImage[] {
	let arr = paths.map((name, j) => {
		let uri = [server, 'gallery', id, i.toString(), name].join('/');
		if (!ratios[j]) ratios[j] = ratio || [1, 1];
		return {
			key: id + '.' + i.toString() + '.' + j.toString(),
			alt: name.toLowerCase().replace(/\s+/g, '_').replace('.jpg', ''),
			index: j,
			src: uri,
			thumbnail: uri,
			width: ratios[j][0],
			height: ratios[j][1],
			caption: name.toLowerCase()
				.replace(/\s+/g, '_')
				.replace('.jpg', '')
		}
	});
	return arr;
}

export default function Grid(props: GridProps): ReactElement {
	const [currentImage, setCurrentImage] = useState(0);
	const [viewerIsOpen, setViewerIsOpen] = useState(false);

	const openLightbox = useCallback((event, { photo, index }) => {
		setCurrentImage(index);
		setViewerIsOpen(true);
	}, []);

	const closeLightbox = () => {
		setCurrentImage(0);
		setViewerIsOpen(false);
	};

	if (props.paths.length <= 3) return (
		<div className='Grid' style={props.style}>
			<div className='grid-flex'>
				{props.photos.map((p, i) => {
					return <img
						key={[p, i].join('.')}
						alt={(p as any).caption}
						{...p as any}
						height={props.targetRowHeight}
						width='auto'
					/>;
				})}
			</div>
		</div>
	)

	return (
		<div className='Grid' style={props.style}>
			<Gallery
				{...props}
				onClick={props.enableLightbox !== false ? openLightbox : () => {}}
			/>
			{props.enableLightbox !== false ? (
				<ModalGateway>
					{viewerIsOpen ? (
						<Modal onClose={closeLightbox}>
							<Lightbox
								onClose={closeLightbox}
								currentImage={currentImage}
								views={props.photos}
							/>
						</Modal>
					) : null}
				</ModalGateway>
			) : null}
		</div>
	);
}